import React from "react";

import {
  Container,
  BoxContainer,
  Heading,
  MainSection,
} from "pages/Messages/Notifications/NotificationsStyled";
import NotificationsTable from "pages/Messages/Notifications/Table";
import AddEmail from "pages/Messages/Notifications/AddEmail";
import { MobileHeader } from "assets/css/globle";
import { useTranslation } from "react-i18next";

export const Notifications = () => {
  const { t } = useTranslation();
  return (
    <>
      <MobileHeader>
        <h4>{t("Notifications")}</h4>
      </MobileHeader>
      <Container>
        <BoxContainer>
          <Heading>
            <h3>{t("Add_email")}</h3>
          </Heading>
          <MainSection>
            <AddEmail />
            <NotificationsTable />
          </MainSection>
        </BoxContainer>
      </Container>
    </>
  );
};
